export const ITEMS_PER_PAGE_USERS = 10;
export const ITEMS_PER_PAGE_PROFILE_CATEGORIES = 10;
export const ITEMS_PER_PAGE_PROFILE_FIELDS = 10;
export const ITEMS_PER_PAGE_ROLES = 10;
export const ITEMS_PER_PAGE_PERMISSIONS = 10;
export const ITEMS_PER_PAGE_DEPARTMENTS = 10;
export const ITEMS_PER_PAGE_POSITIONS = 10;
export const ITEMS_PER_PAGE_GOALS = 10;
export const ITEMS_PER_PAGE_GOAL_FRAMEWORKS = 10;
export const ITEMS_PER_PAGE_RATING_SCALES = 10;
export const ITEMS_PER_PAGE_CUSTOM_FIELD_DEFINITIONS = 10;
export const ITEMS_PER_PAGE_COURSES = 10;
export const ITEMS_PER_PAGE_CATEGORIES = 10;
export const ITEMS_PER_PAGE_ENROLL_USERS = 10;
export const ITEMS_PER_PAGE_SKILL_FRAMEWORKS = 10;
export const ITEMS_PER_PAGE_SKILLS = 10;
export const ITEMS_PER_PAGE_JOB_ASSIGNMENTS = 10;
export const ITEMS_PER_PAGE_COHORTS = 10;
export const ITEMS_PER_PAGE_DEFAULT = 10;
export const ITEMS_PER_PAGE_ASSIGNMENTS = 10;

export const API_DROPDOWN_LIMIT = 100;